import styled from 'styled-components/macro';

export const VersionWrapper = styled.div`
    margin-left: auto;
    span {
        color: red;
    }
`;
